import "./style.scss";

import ButtonCollapse from "components/shared/ButtonCollapse";
import ChannelIcon from "components/shared/ChannelIcon";
import CopyToClipboard from "components/shared/CopyToClipboard";
import { PortalType } from "contexts/portal.context";
import { useContext } from "react";
import { EPortalType } from "store/types";

import ChannelTags from "../ChannelTags";
import type { IChannel } from "../types";

interface TChannel {
    /**
     * channel data
     */
    channel: IChannel;
    /**
     * open channel details (collapse)
     */
    onOpenChannel: (channel: IChannel) => void;
    /**
     * verify if channel is open (collapse)
     */
    isChannelOpen: boolean;
}

const Channel = ({ channel, onOpenChannel, isChannelOpen }: TChannel) => {
    const portalType = useContext(PortalType);
    return (
        <div
            className={`channel-block channel-${channel.id}`}
            style={{ backgroundColor: isChannelOpen ? "#F6F6F6" : undefined }}
            onClick={() => portalType === EPortalType.BOOK && onOpenChannel(channel)}
        >
            <div className="channel-left">
                <div className="channel-icon-square">
                    <ChannelIcon channelKind={channel.kind} color="#6C5BBE" />
                </div>
                <div className="channel-title">
                    <span className="channel-name">{channel.name}</span>
                    {/* {(usesGroups && compensationGroup) &&
                        <span className='channel-compensation-group'>{`${t("Channels.GroupedIn")} ${compensationGroup}`}</span>
                    } */}
                    <CopyToClipboard className="channel-id" label="ID:" color="var(--foreground)">{`${
                        channel?.customIdentifier ?? channel.id
                    }`}</CopyToClipboard>
                </div>
            </div>
            <div className="channel-right">
                <ChannelTags channelData={channel} />
                {portalType === EPortalType.BOOK && <ButtonCollapse collapse={isChannelOpen} />}
            </div>
        </div>
    );
};

export default Channel;
